import Vue from 'vue'
import Vuex from 'vuex'
import selectShop from './modules/selectShop'

Vue.use(Vuex)

export default new Vuex.Store({
    modules:{
        selectShop 
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js